/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
};

const ExpandIcon: FC<IProps> = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 9L12 15L6 9" stroke="#33363F" strokeWidth="2"/>
  </svg>
);

export default ExpandIcon;
